
import { defineComponent, PropType, computed, Ref, ref, toRefs, reactive, watch } from "vue";
import { dayFunc } from "@/hooks/factoryFunc";
export default defineComponent({
  name:"szFform",
  props: {
    /**
     * @param {Array} layout 表单布局
     */
    layout: {
      type: Array as PropType<any[]>,
      default: (): any => [],
    },

    /**
     * 验证规则
     */
    rules: {
      type: Object as PropType<any>,
      default: (): any => {
        return {};
      },
    },

    /**
     * filter
     */
    filter: {
      type: Array as PropType<any[]>,
      default: (): any => [],
    },

    /**
     * @param {Object} 当前表单的值
     */
    modelValue: {
      type: Object as PropType<any>,
      default: (): any => {
        return {};
      },
    },

    /**
     * @param {Object} 表单依赖的 数据源
     */
    source: {
      type: Object as PropType<any>,
      default: (): any => {
        return {};
      },
    },

    /**
     * @param {Boolean} 是否是搜索表单
     */
    searchForm: {
      type: Boolean,
      default: false,
    },

    /**
     * @param {Boolean} 禁用整个表单
     */
    disabledForm: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const form: Ref<any> = ref(null);
    const { dayjs } = dayFunc();
    const propsData: any = reactive(props);

    /**
     * 重置表单
     */
    const reset = () => {
      propsData.layout.forEach((item: any) => {
        if (item.type === "el-double-date-picker") {
          modleData[item.extend[0]] = "";
          modleData[item.extend[1]] = "";
        }
      });
      (form.value as any).resetFields();
      ctx.emit("resetForm");
    };

    /**
     * 验证表单
     */
    const validateFn = () => {
      let result = false;
      form.value.validate((valid: boolean) => {
        result = valid;
      });
      return result;
    };

    /**
     * 搜索表单
     */
    const search = () => {
      ctx.emit("searchForm");
    };

    /**
     * @param componentsMap 组件默认配置表
     */
    const componentsMap = new Map([
      [
        "el-input",
        {
          placeholder: "请输入",
          span: 6,
        },
      ],
      [
        "el-select",
        {
          placeholder: "请选择",
          span: 6,
          bind: {
            key: "key",
            label: "label",
            value: "value",
          },
        },
      ],
      [
        "el-select-v2",
        {
          placeholder: "请选择",
          span: 6,
          options:[],
          bind: {
            props:{
              key: "key",
              label: "label",
              value: "value",
            }
          },
        },
      ],
      
      [
        "el-cascader",
        {
          placeholder: "请选择",
          span: 6,
        },
      ],
      [
        "el-date-picker",
        {
          placeholder: "请选择日期",
          span: 6,
          bind: {
            type: "date",
          },
        },
      ],
      [
        "el-date-picker-year",
        {
          placeholder: "请选择年份",
          span: 6,
          bind: {
            type: "year",
          },
        },
      ],
      [
        "el-date-picker-month",
        {
          placeholder: "请选择月份",
          span: 6,
          bind: {
            type: "month",
          },
        },
      ],
      [
        "el-double-date-picker",
        {
          placeholder: "请选择日期",
          span: 6,
          bind: {
            type: "date",
          },
        },
      ],
      [
        "datetimerange",
        {
          placeholder: "请选择日期",
          span: 6,
          bind: {
            type: "date",
          },
        },
      ],
    ]);

    const modleData = propsData.modelValue;

    /**
     * @method createLayout 生成表单布局
     */
    const createLayout = computed((): any => {
      /**
       * @param MAX_GRID    默认 最大栅格数
       * @param sum         默认 总计
       * @param count       默认 计数
       */
      const layoutMulti: any = [];
      const MAX_GRID = 24;
      let index = 0;

      // 1、过滤掉不在 组件信息配置中的列表
      // 2、填充span 数据
      // 3、生成一个id优化diff算法
      const layout: any[] = propsData.layout.filter(
        (formItem: any, index: number) => {
          let field = formItem.field;
          let formItemType = formItem.type;
          let isExist =
            componentsMap.has(formItemType) &&
            Boolean(field) &&
            !propsData.filter.includes(field);

          // 优化diff
          formItem.id = Number(
            Math.random().toString().substr(3, 8) + Date.now()
          ).toString(8);

          if (isExist) {
            let components: any = componentsMap.get(formItemType);
            //    合并bind
            formItem.bind = {
              ...(components.bind || {}),
              ...(formItem.bind || {}),
            };

            //    合并属性配置
            !formItem.span ? (formItem.span = components.span) : false;

            !formItem.placeholder
              ? (formItem.placeholder = components.placeholder)
              : false;

            return true;
          } else if (formItem.slot && !propsData.filter.includes(formItem.slot)) {
            // 如果是使用自定义卡槽

            !formItem.span ? (formItem.span = 6) : false;
            return true;
          } else {
            console.warn(
              `props---> layout[${index}] 缺省 field 字段,或者字段值为空!。`
            );
            return false;
          }
        }
      );

      // 转换成二维数组
      for (let element of layout) {
        if (layoutMulti[index]) {
          const sum = layoutMulti[index]
            .map((el: any) => el.span)
            .reduce((sum: number, nex: number) => sum + nex);

          if (sum >= MAX_GRID) {
            index++;
            layoutMulti.push([element]);
          } else {
            layoutMulti[layoutMulti.length - 1].push(element);
          }
        } else {
          layoutMulti.push([element]);
        }
      }

      // 1、如果是搜索表单
      // 2、计算功能按钮放置的位置

      if (propsData.searchForm) {
        const sum = layoutMulti[layoutMulti.length - 1]
          .map((el: any) => el.span)
          .reduce((sum: number, nex: number) => sum + nex);

        if (sum > 18) {
          layoutMulti.push([
            {
              type: "searchForm",
              span: 24,
              paddingTop: false,
            },
          ]);
        } else {
          layoutMulti[layoutMulti.length - 1].push({
            type: "searchForm",
            span: 24 - sum,
            paddingTop: true,
          });
        }
      }
      return layoutMulti;
    });

    const handleChange = ({ field, type, value, extend }: any) => {
      switch (type) {
        case "el-date-picker":
          {
            modleData[field] =
              value === null || value == ""
                ? ""
                : dayjs(value).format("YYYY-MM-DD");
            return;
          }
          break;
        case "el-date-picker-year":
          {
            modleData[field] =
              value === null || value == ""
                ? ""
                : dayjs(value).format("YYYY");
            return;
          }
          break;
        case "el-date-picker-month":
          {
            modleData[field] =
              value === null || value == ""
                ? ""
                : dayjs(value).format("YYYY-MM");
            return;
          }
          break;
        case "el-double-date-picker":
          {
            if (value && value.length == 2) {
              modleData[extend[0]] = dayjs(value[0]).format("YYYY-MM-DD");
              modleData[extend[1]] = dayjs(value[1]).format("YYYY-MM-DD");
            } else {
              modleData[extend[0]] = "";
              modleData[extend[1]] = "";
              return;
            }
          }
          break;
        case "datetimerange":
          {
            if (value && value.length == 2) {
              modleData[extend[0]] = dayjs(value[0]).format("YYYY-MM-DD HH:mm");
              modleData[extend[1]] = dayjs(value[1]).format("YYYY-MM-DD HH:mm");
            } else {
              modleData[extend[0]] = "";
              modleData[extend[1]] = "";
              return;
            }
          }
          break;
      }
    };

    return {
      handleChange,
      validateFn,
      createLayout,
      modleData,
      reset,
      search,
      form,
    };
  },
});
